import { render, staticRenderFns } from "./SkillsInventoryFilters.vue?vue&type=template&id=2e923702&scoped=true&"
import script from "./SkillsInventoryFilters.vue?vue&type=script&lang=js&"
export * from "./SkillsInventoryFilters.vue?vue&type=script&lang=js&"
import style0 from "./SkillsInventoryFilters.vue?vue&type=style&index=0&id=2e923702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e923702",
  null
  
)

export default component.exports